import React from 'react';
import classNames from 'classnames';
import './buttons.scss';

class ButtonPrimary extends React.Component {
  render() {
    const {
      buttonText,
      isDisabled,
      onClick,
      hasArrow,
      tabIndex,
      autoFocus,
      hasPlay,
      id,
      ariaHidden,
      ariaLabel,
    } = this.props;
    const buttonId = id ? id : 'button-primary';
    const buttonClass = classNames(
      'button-primary',
      { disabled: isDisabled },
      { enabled: !isDisabled },
    );
    return (
      <button
        className={buttonClass}
        onClick={onClick}
        tabIndex={tabIndex}
        id={buttonId}
        autoFocus={autoFocus}
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
      >
        <div className="button-text">{buttonText}</div>
        {hasArrow && (
          <img
            className="img-arrow"
            alt=""
            src="/images/white-right-arrow.png"
          />
        )}
        {hasPlay && <div className={hasPlay}></div>}
      </button>
    );
  }
}
export default ButtonPrimary;
